import 'angular:locale/data:nl';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "nl";
